import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject, catchError, map, of } from "rxjs";
import {
  IChangeReqStatusBody,
  IRequestObj,
  IRequestObjBack,
} from "../interfaces/requests.interface";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReqManagementService {
  reqManagementEndpoint = `${environment.apiUrlCap}/api/deletionLog`;
  private requestListSubject = new Subject<IRequestObj[]>();
  private requestUpdateSubject = new Subject<void>();

  constructor(private http: HttpClient) {}

  get requestList() {
    return this.requestListSubject.asObservable();
  }
  get requestUpdate$() {
    return this.requestUpdateSubject.asObservable();
  }

  triggerUpdate() {
    this.requestUpdateSubject.next();
  }

  getRequests(
    paramName: "solicitanteId" | "autorizaId",
    fromUserId: number
  ): Observable<IRequestObjBack[]> {
    const params = new HttpParams().set(paramName, fromUserId);

    return this.http
      .get<ResponseDataInterfaces<IRequestObjBack[]>>(
        `${this.reqManagementEndpoint}`,
        { params }
      )
      .pipe(
        map(({ data }) => data.reverse()),
        catchError(() => of([]))
      );
  }

  changeRequestStatus(changeStatusObj: IChangeReqStatusBody) {
    return this.http
      .put<ResponseDataInterfaces<IRequestObj>>(
        `${this.reqManagementEndpoint}`,
        changeStatusObj
      )
      .pipe(map(({ data }) => data));
  }

  createDeletionRequest(newDeletionReq: IRequestObj) {
    return this.http
      .post<ResponseDataInterfaces<IRequestObj>>(
        `${this.reqManagementEndpoint}`,
        newDeletionReq
      )
      .pipe(map(({ data }) => data));
  }
}
